import { Component, OnInit } from '@angular/core';
import { Service } from '../../../services';
import { GlobalService } from '../../../global.service';
import { LoadingScreenService } from '../../../services/loading-screen/loading-screen.service';
@Component({
  selector: 'app-security-questions',
  templateUrl: './security-questions.component.html',
  styleUrls: ['./security-questions.component.sass']
})
export class SecurityQuestionsComponent implements OnInit {

  public questionsData;
  public challengeQuestionsData;
  public questionID1:Object;
  public questionID2:Object;
  public pregunta1:string;
  public pregunta2:string;
  public popPreguntasSeguridad:boolean;
  constructor(private services: Service,private global:GlobalService,private loadingScreenService :LoadingScreenService) { }

  ngOnInit() {
    if(this.global.sessionReview()==true){
      this.getquestions(sessionStorage.getItem("token"));
    }
  }
  getquestions(token){
    this.services.getquestions(token).subscribe(data =>{
      if(data.hasError ==false){ 
          sessionStorage.setItem("getquestions",btoa(JSON.stringify(data)));
          this.questionsData=JSON.parse(atob(sessionStorage.getItem("getquestions"))).QuestionsItemsList;
          this.services.getChallengeQuestions2(token).subscribe(data =>{
            if(data.hasError ==false){
              
             sessionStorage.setItem("getChallengeQuestions2",btoa(JSON.stringify(data)));
             this.challengeQuestionsData=JSON.parse(atob(sessionStorage.getItem("getChallengeQuestions2"))).ResponseList;
             if(this.challengeQuestionsData){
                    for(var i=0;i<this.challengeQuestionsData.length;i++){
                        if(i===0){
                            this.questionID1=this.challengeQuestionsData[i].questionID;
                            this.pregunta1=this.challengeQuestionsData[i].response;
                        }
                        if(i===1){
                            this.questionID2=this.challengeQuestionsData[i].questionID;
                            this.pregunta2=this.challengeQuestionsData[i].response;
                        }
                    }
                }
            }
            else{
              this.loadingScreenService.stopLoading();
              this.global.notif(data.ErrorDesc);
            }
          });
      }
      else{
        this.loadingScreenService.stopLoading();
        this.global.notif(data.ErrorDesc);
      }
    });
  }

  aceptarPreguntas() {
    this.global.validateSession();
    if (this.questionID1!==''&&this.questionID1!==undefined) {
          if(this.pregunta1 !== ''&&this.pregunta1 !== undefined){
          this.services.setchallengequestions(sessionStorage.getItem("token"),this.questionID1,this.pregunta1).subscribe(data =>{
              if (data.hasError ==false) {
                  if(this.questionID2!==''&&this.questionID2!==undefined){
                      if (this.pregunta2 !== ''&&this.pregunta2 !== undefined) {
                          this.loadingScreenService.startLoading();
                          this.popPreguntasSeguridad = false;
                          sessionStorage.setItem("popPreguntasSeguridad",btoa(JSON.stringify(this.popPreguntasSeguridad)));

                          this.services.setchallengequestions(sessionStorage.getItem("token"),this.questionID2,this.pregunta2).subscribe(data =>{
                            if(data.hasError ==false){
                              this.loadingScreenService.stopLoading();
                              this.global.notif("Se han Actualizado las preguntas de seguridad. ");
                            }
                            else{
                              this.loadingScreenService.stopLoading();
                              this.global.notif(data.errorDesc);
                            }
                          });
                      }
                      else {
                          this.global.notif("Debe colocar una respuesta para la segunda pregunta.");
                      }
                  }
                  else{
                      this.global.notif("Debe seleccionar la segunda pregunta.");
                  }
              } 
              else {
                  this.global.notif(data.errorDesc);    
              }
          });
        }
        else{
          this.global.notif("Debe colocar una respuesta para la primera pregunta.");
        }
    }
    else {
        this.global.notif("Debe seleccionar la primera pregunta secreta.");
    }
  }
}